import {
  AfterViewInit,
  Component,
  HostListener,
  Inject,
  inject,
  NgZone,
  OnDestroy,
  PLATFORM_ID,
  Renderer2,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  GuardsCheckStart,
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  Route,
  RouteConfigLoadStart,
  Router,
} from '@angular/router';
import { CookieUtil } from '@utils/cookies';
import { CampaignAttributionService } from '@utils/campaign-attribution';
import { Title } from '@angular/platform-browser';
import { UtilsMethods_Services } from '@utils/utils';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '@enviroment/environment';
import { getDataCampaign } from '@utils/get-campaign';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { ValidateTokenService } from '@apiShared/user/token/validate-token.service';
import { SignOut_Util } from '@utils/sign-out';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertConfirmComponent } from './resources-alerts/alert-confirm/alert-confirm.component';
import { CloseModal } from '@class/close-modal/close-modal';
import { Globals } from '@config/global';
import { NotificacionService } from '@utils/notificacion';
import { ScriptLoaderService } from '@apiShared/scripts/scripts-loaders.service';
import { AnalyticsManagerService } from './services/form-analytics';
import { RobotsService } from '@apiShared/robots/robots.service';
import { GlobalQueryParamsPreserverService } from '@apiShared/querys-params-preserver/querys-params-preserver.service';
import { ScreenService } from '@utils/screen';
import { AcquisitionChannelUtil } from '@utils/acquisition-channel.util';
import { FlowPageSeoService } from '@apiShared/seo/flow-page-seo.service';
import { JsonLdService } from '@apiShared/seo/json-ld.service';
import { buildOrganizationSchema, buildWebSiteSchema } from '@apiShared/seo/json-ld.schemas';
import { ClarityUserContextService } from '@services/clarity/clarity-user-context.service';
import { ProcessRouteLoadingService } from '@services/process-route/process-route-loading.service';
import { ProcessRouteGuard } from '@core/guards/process-route.guard';
import { BrazeService } from '@services/braze/braze.service';
import { GetUserMeService } from '@apiShared/user/get/get-user-me.service';

declare let gtag: Function;

declare global {
  interface Window {
    /**
     * Lo lee el embed de HubSpot antes del primer request del widget.
     * `messagesPageUri` es el valor del header `X-HubSpot-Messages-Uri`.
     */
    messagesConfig?: {
      messagesPageUri?: string;
    };
  }

  var HubSpotConversations: {
    widget: {
      remove: () => void;
      load: () => void;
      open: () => void;
    };
  };
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements AfterViewInit, OnDestroy {
  private readonly processRouteLoading = inject(ProcessRouteLoadingService);
  readonly processRouteLoading$ = this.processRouteLoading.loading$;

  private tokenExpirationSubscription!: Subscription;
  private destroy$ = new Subject<void>();

  resolution?: number = 0;
  env = environment;
  title = 'MejorCDT';
  retryAttempts = 5; // Número máximo de intentos para checkQueryParam
  favicons!: { [key: string]: HTMLLinkElement };
  mouseInactive: number = 0;
  flagMouseActive: boolean = false;
  flagModalDownloadApp: boolean = false;
  timeMouseActive: number = 35000;
  observer: MutationObserver | undefined;
  pageNotAllowedBonusGift: any = [
    '/preguntas/coltefinanciera/flamingo',
    '/preguntas-ban100',
    '/preguntas-bancamia',
    '/preguntas-bancow',
    '/preguntas-bancomundomujer',
    '/preguntas-mibanco',
    '/preguntas-coltefinanciera',
    '/preguntas-credifamilia',
    '/preguntas-iris',
    '/datos-personales',
    '/datos-financieros',
    '/sube-tus-documentos',
    '/asegura-tu-tasa',
    '/transfiere-el-dinero',
    '/cdt-completado',
    '/ops/dashboard',
    '/portal/login',
    '/portal/dashboard',
    '/portal/referrer',
    '/login',
    '/verificando-firma',
    '/mis-procesos',
    '/continuar-proceso',
    '/no-podemos-continuar-con-tu-proceso',
    '/firma-los-documentos-en-fisico',
    '/trabajo',
    '/validar-identidad',
    '/hoy-los-bancos-ofrecen',
    '/pauta/remarketing/hoy-los-bancos-ofrecen',
    '/pauta/llamada/hoy-los-bancos-ofrecen',
    '/pauta/control/hoy-los-bancos-ofrecen',
    '/cdt-simulador?promo=gift-voucher',
    '/golf18',
    '/a-unos-minutos-de-abrir-tu-cdt',
    '/cdt-simulador',
    '/orden-inversion',
    '/cancelacion',
    '/4B6XN8K2H7VY3W9M5Q1Z9A3JN7M5D1H8S4L0F2K',
    '/dias-azules',
    '/sueldo-inteligente',
    '/referidos',
    '/referidos/terminos',
    '/cdt-nicolasabril',
    '/cdt-arenalfa',
    '/cdt-financiatuvida',
    '/cdt-claudiauribe',
    '/confirma-tus-datos',
    '/bienvenida-usuario-retorno',
    '/preguntas-credifamilia',
    '/v2/preguntas/coltefinanciera/flamingo?campaign=Flamingo',
    '/v2/preguntas-ban100',
    '/v2/preguntas-bancamia',
    '/v2/preguntas-bancow',
    '/v2/preguntas-bancomundomujer',
    '/v2/preguntas-mibanco',
    '/v2/preguntas-credifamilia',
    '/v2/preguntas-coltefinanciera',
    '/v2/preguntas-iris',
    '/v2/preguntas-bancounion',
    '/v2/preguntas-cdturbo',
    '/v2/datos-personales',
    '/v2/datos-financieros',
    // '/cdt-turbo',
    '/club-cdt',
    '/ab-testing/cdt-simulador',
    '/moneycon',
    '/legal/bono-regalo',
    '/cuentanos-sobre-ti',
    '/magical_experience/cuentanos-sobre-ti',
  ];

  @ViewChild('appContainer', { read: ViewContainerRef }) container!: ViewContainerRef;
  timeoutId: any;
  chatLoadedByScroll: boolean = false;
  private hubspotListenersAdded = false;
  private chatScrollListener?: () => void;
  /** true = no cargar el widget/script de chat HubSpot (ninguna ruta ni interacción). */
  private readonly FORCE_NO_LOAD_CHAT = false;

  private readonly campaignAttribution = inject(CampaignAttributionService);

  constructor(
    private ngZone: NgZone,
    private cookies: CookieUtil,
    private utils: UtilsMethods_Services,
    private signOut: SignOut_Util,
    private closeModal: CloseModal,
    private notification: NotificacionService,
    private _getDataCampaign: getDataCampaign,
    private modal: NgbModal,
    private validateToken: ValidateTokenService,
    private router: Router,
    private renderer: Renderer2,
    private globals_var: Globals,
    private scriptLoader: ScriptLoaderService,
    private analyticsManager: AnalyticsManagerService,
    private clarityUserContext: ClarityUserContextService,
    private titlePage: Title,
    private _screenService: ScreenService,
    private robotsService: RobotsService, // No remover
    private queryParamsPreserver: GlobalQueryParamsPreserverService, // No remover
    private acquisitionChannel: AcquisitionChannelUtil, // No remover
    private flowPageSeoService: FlowPageSeoService,
    private jsonLdService: JsonLdService,
    private braze: BrazeService,
    private getUserMeService: GetUserMeService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    if (isPlatformBrowser(this.platformId)) {
      this._screenService.initialize();
      this.favicons = {
        ico16: document.querySelector('link[rel="icon"][sizes="16x16"]') as HTMLLinkElement,
        ico32: document.querySelector('link[rel="icon"][sizes="32x32"]') as HTMLLinkElement,
        ico48: document.querySelector('link[rel="icon"][sizes="48x48"]') as HTMLLinkElement,
        ico64: document.querySelector('link[rel="icon"][sizes="64x64"]') as HTMLLinkElement,
        ico128: document.querySelector('link[rel="icon"][sizes="128x128"]') as HTMLLinkElement,
      };

      this.isMobileSubscribe();
      this.campaignVIP();

      if (this.env.BRAND != 'mcdt') {
        this.utils.loadWhiteLabelData(this.env.BRAND).then((data) => {
          this.titlePage.setTitle(data.seo.title);
        });
      }
    }

    // Inicializar el contexto de Clarity, enviando parametros de cookies para tracking
    this.clarityUserContext.start();
  }

  ngOnInit(): void {
    // JSON-LD Organization site-wide. Se emite sin guardas de plataforma para que
    // salga también en el HTML del SSR (Googlebot / AI Overviews lo reciben inicial).
    if (this.env.BRAND === 'mcdt') {
      this.jsonLdService.setSchema('organization', buildOrganizationSchema());
      this.jsonLdService.setSchema(
        'website',
        buildWebSiteSchema({
          description:
            'Plataforma digital colombiana para comparar, simular y abrir Certificados de Depósito a Término (CDT).',
        }),
      );
    }

    if (isPlatformBrowser(this.platformId)) {
      this.acquisitionChannel.detectAndSave();
      this.subscribeProcessRouteLoading();

      const check_id_token_user = this.cookies.check('id_token_user');
      if (check_id_token_user) {
        this.startTokenExpirationCheck();
      }

      this.backToStep();
      this.campaignAttribution.persistFromCurrentUrl();
      this.router.events.pipe(takeUntil(this.destroy$)).subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.campaignAttribution.persistFromCurrentUrl();
        }
      });

      this.LoadChatFaviconBrand();
      // Solo configura listeners (0 impact), carga diferida mantenida
      this.analyticsManager.initializeAnalytics();

      // Cargar otros scripts third-party diferidos
      this.scriptLoader.initThirdPartyListeners();

      // Braze Web SDK: carga diferida (interacción + idle), no-op si la marca lo apaga.
      this.scheduleBrazeInitialization();
    }
  }

  /**
   * Programa la inicialización de Braze con la misma política que el resto de terceros:
   * primera interacción o fallback tras load, y ejecución en idle. Nunca en LCP ni en SSR.
   */
  private brazeScheduled = false;
  private brazeInitTriggered = false;
  private readonly brazeInteractionEvents = ['scroll', 'mousemove', 'touchstart'];

  private scheduleBrazeInitialization(): void {
    // isConfigEnabled() es false en marcas sin `braze` en environment (Coltefinanciera).
    if (!isPlatformBrowser(this.platformId) || !this.braze.isConfigEnabled() || this.brazeScheduled) {
      return;
    }
    this.brazeScheduled = true;

    this.ngZone.runOutsideAngular(() => {
      this.brazeInteractionEvents.forEach((event) => {
        document.addEventListener(event, this.triggerBrazeInit, { once: true, passive: true });
      });

      const fallback = () => setTimeout(this.triggerBrazeInit, 8000);
      if (document.readyState === 'complete') {
        fallback();
      } else {
        window.addEventListener('load', fallback, { once: true });
      }
    });
  }

  private triggerBrazeInit = (): void => {
    if (this.brazeInitTriggered) return;
    this.brazeInitTriggered = true;

    this.brazeInteractionEvents.forEach((event) => {
      document.removeEventListener(event, this.triggerBrazeInit);
    });

    const run = () => {
      void this.initializeBraze();
    };
    if ('requestIdleCallback' in window) {
      (window as any).requestIdleCallback(run, { timeout: 3000 });
    } else {
      setTimeout(run, 0);
    }
  };

  private async initializeBraze(): Promise<void> {
    try {
      await this.braze.initialize();

      // Si ya hay cookie user_id, identificar de una vez.
      const identified = await this.braze.bootstrapIdentityFromCookie();
      if (identified) return;

      // Usuario logueado pero sin cookie user_id (caso post-login): resolver via GET_USER_ME.
      const idToken = this.cookies.get('id_token_user');
      if (!idToken) return;

      const data = await this.getUserMeService.GET_USER_ME(idToken);
      if (data?.status === 200 && data?.body?.id) {
        await this.braze.initializeForUser({
          id: data.body.id,
          fullName: data.body.full_name,
          email: data.body.correo,
          phone: data.body.phone,
        });
      }
    } catch {
      // Braze no debe romper el arranque.
    }
  }

  ngAfterViewInit(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    /* Se comenta la carga de scroll por analisis y comportamiento */
    /* this.renderer.listen('window', 'scroll', () => {
      this.onWindowScroll();
    }); */

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        if (this.env.BRAND === 'mcdt') {
          const seo = this.flowPageSeoService.resolveSeoFromSnapshot(this.router.routerState.snapshot.root);
          if (seo) {
            this.flowPageSeoService.apply(seo);
          }
        }

        setTimeout(() => {
          this.activateCampaign();
        }, 100); // Permite que el navegador renderice primero

        // Cargar HammerJS dinámicamente
        this.loadHammerJs();

        const ID_APLICATION_TUBO_MCDT: any = document.getElementById('aplication-tubo-mcdt');
        if (ID_APLICATION_TUBO_MCDT) {
          while (ID_APLICATION_TUBO_MCDT.classList.length > 0) {
            ID_APLICATION_TUBO_MCDT.classList.remove(ID_APLICATION_TUBO_MCDT.classList.item(0));
          }

          const path = window.location.pathname.replaceAll('/', '_');
          if (path) {
            this.renderer.addClass(ID_APLICATION_TUBO_MCDT, path);
          }
        }

        // Lógica unificada para recargar el chat/favicon en la navegación
        this.ngZone.run(() => {
          setTimeout(() => {
            this.retryAttempts = 5;
            this.LoadChatFaviconBrand();
          }, 1000);
        });

        this.addStylesRemoveInViewApp();
      }
    });
  }

  ngOnDestroy(): void {
    this.stopObserving();
    this.removeChatScrollListener();
    this.destroy$.next();
    this.destroy$.complete();
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  /**
   * @description Suscribe al servicio de pantalla para detectar si es móvil.
   * Actualiza la variable `resolution` según el estado del servicio.
   */
  isMobileSubscribe() {
    this._screenService.isMobile$.pipe(takeUntil(this.destroy$)).subscribe((screen) => {
      this.resolution = screen;
    });
  }

  addStylesRemoveInViewApp() {
    if (this.utils.isViewApp()) {
      // Agregar estilos para la vista de app
      this.renderer.addClass(document.getElementById('project-mcdt'), 'view-app');
    }
  }

  stopObserving() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  private subscribeProcessRouteLoading(): void {
    this.showLoadingForInitialProcessRoute();

    this.router.events.pipe(takeUntil(this.destroy$)).subscribe((event) => {
      // El chunk de la ruta se descarga antes de correr los guardianes: también es espera.
      if (event instanceof RouteConfigLoadStart && this.routeUsesProcessRouteGuard(event.route)) {
        this.processRouteLoading.show();
        return;
      }

      if (event instanceof GuardsCheckStart && this.hasProcessRouteGuard(event.state.root)) {
        this.processRouteLoading.show();
        return;
      }

      if (event instanceof NavigationEnd || event instanceof NavigationCancel || event instanceof NavigationError) {
        this.processRouteLoading.hideWithDelay();
      }
    });
  }

  /**
   * Activa el overlay antes de que arranque la primera navegación.
   *
   * Con `initialNavigation: 'enabledNonBlocking'` la app pinta el shell antes de resolver
   * los guardianes, así que sin esto la pantalla queda en blanco (el `router-outlet` está
   * vacío) mientras `get-process` y `validate-rate-changing` responden. La ruta se deduce
   * de la configuración del router para no duplicar el listado de rutas del tubo.
   */
  private showLoadingForInitialProcessRoute(): void {
    const path = window.location.pathname.replace(/^\/+/, '').split('?')[0];
    const isProcessRoute = this.router.config.some(
      (route) => route.path === path && this.routeUsesProcessRouteGuard(route),
    );

    if (isProcessRoute) {
      this.processRouteLoading.show();
    }
  }

  private routeUsesProcessRouteGuard(route: Route): boolean {
    return (route.canActivate ?? []).includes(ProcessRouteGuard);
  }

  private hasProcessRouteGuard(route: ActivatedRouteSnapshot): boolean {
    const guards = route.routeConfig?.canActivate || [];

    if (guards.includes(ProcessRouteGuard)) {
      return true;
    }

    return route.children.some((childRoute) => this.hasProcessRouteGuard(childRoute));
  }

  loadHammerJs() {
    if (isPlatformBrowser(this.platformId)) {
      // Solo cargar HammerJS si la ruta actual lo necesita
      const currentPath = window.location.pathname;
      const routesThatNeedHammer = [
        '/', // Home con carruseles
        '/home', // Home module
        '/cdt-simulador', // Simulador con gestures
        '/mejores-bancos-para-cdt-hoy', // Carruseles
        '/mejores-tasas-para-cdt-hoy', // Carruseles
        '/club-cdt', // Interacciones touch
        // '/cdt-turbo', // Carruseles
        '/portal/dashboard', // Dashboard interactivo
      ];

      // También cargar para rutas que empiecen con ciertos patrones
      const routePatternsThatNeedHammer = [
        '/mejores-cdt-', // Rutas de mejores CDT del mes
        '/cdt-', // Páginas específicas de bancos
      ];

      const needsHammer =
        routesThatNeedHammer.includes(currentPath) ||
        routePatternsThatNeedHammer.some((pattern) => currentPath.startsWith(pattern));

      if (needsHammer) {
        import('hammerjs').then(() => {});
      }
    }
  }

  activateCampaign() {
    this._getDataCampaign.activateCampaignData().subscribe({
      error: (err) => console.error('Error: ', err),
    });
  }

  campaignVIP() {
    this.notification.receiveNotificacion.subscribe((data: any) => {
      let api = data.api;
      switch (api) {
        case 'api_notification_activate_VIP':
          const ID_PROJECT_MCDT_ELEM = document.getElementById('project-mcdt');
          if (ID_PROJECT_MCDT_ELEM) {
            this.renderer.addClass(ID_PROJECT_MCDT_ELEM, 'vip-activate');
          }
          break;

        case 'send_notification_process_validation_error':
          this.showProcessValidationError(data.message);
          break;

        default:
          break;
      }
    });
  }

  private showProcessValidationError(message: string): void {
    const modalRef = this.modal.open(AlertConfirmComponent, {
      centered: true,
      size: 'sm',
    });

    modalRef.componentInstance.modalData = {
      title: `
        <div class="d-block text-center">
          <i class="mi mi-md mi-bell"></i>
          <div class="d-block color-blue-100">
            Atención
          </div>
        </div>
      `,
      message,
      no_padding_header: false,
      textButtons: {
        confirm: {
          text: 'Entendido',
          id: 'process_validation_error_confirm',
        },
      },
    };
    modalRef.componentInstance.getResult().subscribe(() => {
      modalRef.close();
    });
  }

  /*
   * Genera un mensaje dinámico dependiendo del día de la semana.
   * Si hoy es jueves antes de las 3:00 PM, devuelve un mensaje específico.
   * Si hoy es viernes, devuelve un mensaje para el próximo viernes.
   * En cualquier otro día, devuelve un mensaje para el próximo viernes después del día actual.
   * @returns El mensaje dinámico generado.
   */
  generateDynamicMessage(): string {
    const today = new Date();
    const dayOfWeek = today.getDay(); // 0 (Sunday) to 6 (Saturday)
    const textContinue = 'y recibe gratis un bono regalo de <b>$50.000</b>';
    const months = [
      'Enero',
      'Febrero',
      'Marzo',
      'Abril',
      'Mayo',
      'Junio',
      'Julio',
      'Agosto',
      'Septiembre',
      'Octubre',
      'Noviembre',
      'Diciembre',
    ];
    // Verificar si hoy es jueves y si es antes de las 3:00 PM
    if (dayOfWeek === 5) {
      const now = new Date();
      const cutoffTime = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 15, 0, 0); // 3:00 PM

      if (now < cutoffTime) {
        return '<b>hoy antes de las 3:00pm</b> para que recibas gratis un bono regalo de <b>$50.000</b> ';
      }
    }
    // Si hoy es viernes, mostrar el mensaje para el próximo viernes
    else if (dayOfWeek === 5) {
      const nextFriday = new Date(today);
      nextFriday.setDate(today.getDate() + 7); // Obtener el próximo viernes

      const day = nextFriday.getDate();
      const monthIndex = nextFriday.getMonth();
      const month = months[monthIndex].charAt(0).toUpperCase() + months[monthIndex].slice(1);
      const year = nextFriday.getFullYear();

      return `<b>antes del próximo Viernes ${day} de ${month} de ${year}</b> a las 3:00pm,  ${textContinue}`;
    }

    // Si no es jueves ni viernes, mostrar el mensaje para el próximo viernes después del día actual
    const nextFriday = new Date(today);
    nextFriday.setDate(today.getDate() + ((5 - dayOfWeek + 7) % 7)); // Obtener el próximo viernes

    const day = nextFriday.getDate();
    const monthIndex = nextFriday.getMonth();
    const month = months[monthIndex].charAt(0).toUpperCase() + months[monthIndex].slice(1);
    const year = nextFriday.getFullYear();

    return `<b>antes del próximo Viernes ${day} de ${month} de ${year}</b> a las 3:00pm, ${textContinue}`;
  }

  acceptedAsGift() {
    this.cookies.save('activate_promo', 'true', 1);
    this.router.navigate(['/cdt-simulador'], { queryParams: { promo: 'gift-voucher' } });
  }

  openAlertConfirmation(
    modalData: { title: string; message: string; textButtons: {}; no_padding_header: boolean },
    execute: () => void,
  ) {
    if (this.mouseInactive <= 1) {
      const modalRef = this.modal.open(AlertConfirmComponent, {
        centered: true,
        backdrop: 'static',
        size: 'modal-alert-bono-regalo-50k-zoom',
      });
      modalRef.componentInstance.modalData = modalData;
      modalRef.componentInstance.getResult().subscribe((result: boolean) => {
        if (result) {
          execute();
        }
      });
    }
  }

  startTokenExpirationCheck(): void {
    this.tokenExpirationSubscription = this.validateToken.getTokenExpirationStatus().subscribe((isExpired: boolean) => {
      if (isExpired) {
        if (this.cookies.get('id_token_user')) {
          this.signOut.SignOut('');
          this.stopTokenExpirationCheck();
          this.closeModal._CloseModal('btn-close-modal-loading');
          this.router.navigate(['/portal/login'], {
            queryParams: {
              returnUrl: this.router.url,
            },
          });
        }
      }
    });
  }

  stopTokenExpirationCheck(): void {
    if (this.tokenExpirationSubscription) {
      this.tokenExpirationSubscription.unsubscribe();
    }
  }

  /**
   * Registra la carga del script de HubSpot para la primera interacción del usuario.
   */
  private scheduleHubspotLoadOnInteraction() {
    if (this.FORCE_NO_LOAD_CHAT) return;
    // Si ya están registrados o el script ya se cargó (p.ej. por scroll), no hacer nada
    if (this.hubspotListenersAdded || this.chatLoadedByScroll) return;

    this.hubspotListenersAdded = true;

    this.ngZone.runOutsideAngular(() => {
      // Lista de eventos de interacción
      const events: string[] = ['scroll', 'mousemove', 'touchstart'];

      // Agenda la descarga en idle para no competir con el evento que mide INP.
      events.forEach((event) => {
        document.addEventListener(event, this.scheduleHubspotScriptLoad, { once: true, passive: true });
      });

      // Fallback tardío contado desde window.load, fuera de la ventana crítica de LCP.
      const fallback = () => setTimeout(this.scheduleHubspotScriptLoad, 10000);
      if (document.readyState === 'complete') {
        fallback();
      } else {
        window.addEventListener('load', fallback, { once: true });
      }
    });
  }

  private scheduleHubspotScriptLoad = () => {
    const events: string[] = ['scroll', 'mousemove', 'touchstart'];
    events.forEach((event) => {
      document.removeEventListener(event, this.scheduleHubspotScriptLoad);
    });

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(this.loadHubspotScriptNow, { timeout: 2500 });
    } else {
      setTimeout(this.loadHubspotScriptNow, 0);
    }
  };

  /**
   * La función que finalmente carga el script de HubSpot.
   * Se usa 'bind(this)' o una arrow function para mantener el contexto.
   */
  private loadHubspotScriptNow = () => {
    if (this.FORCE_NO_LOAD_CHAT) return;
    this.addScriptToHead(this.globals_var.HUBSPOT_PORTAL_SCRIPT);
  };

  /**
   * Orquesta la lógica para cargar el chat de HubSpot y actualizar favicons según la ruta, campaña y condiciones de la página.
   * Separa la lógica en métodos auxiliares para mejorar la legibilidad y el mantenimiento.
   */
  LoadChatFaviconBrand() {
    if (!isPlatformBrowser(this.platformId)) return;

    if (this.FORCE_NO_LOAD_CHAT) {
      window.HubSpotConversations?.widget?.remove();
    }

    const url = new URL(window.location.href);
    const params = url.searchParams;
    const campaignParam = params.get('campaign');
    const locationPath = window.location.pathname;
    const is_active_campaign_month = this.utils.isCampaignMonthReturnBool();
    const detect_screen_mode = !!this.utils.detectScreenMode();

    const views_no_loads_chaths_is_active_campaign_month = new Set(['/', '/cdt-cupido', '/dias-azules']);
    const no_load_chaths_onpage = new Set([
      '/v2/preguntas/coltefinanciera/flamingo?campaign=Flamingo',
      '/v2/preguntas-ban100',
      '/v2/preguntas-bancamia',
      '/v2/preguntas-bancow',
      '/v2/preguntas-bancomundomujer',
      '/v2/preguntas-mibanco',
      '/v2/preguntas-credifamilia',
      '/v2/preguntas-coltefinanciera',
      '/v2/preguntas-iris',
      '/v2/preguntas-cdturbo',
      '/v2/preguntas-koa',
      '/v2/datos-personales',
      '/v2/datos-financieros',
      '/confirma-tus-datos',
      '/cdt-simulador',
      '/cdt-turbo',
      '/bienvenida-usuario-retorno',
      '/widget-simulador',
      '/pauta/remarketing/hoy-los-bancos-ofrecen',
      '/pauta/llamada/hoy-los-bancos-ofrecen',
      '/pauta/control/hoy-los-bancos-ofrecen',
      '/hoy-los-bancos-ofrecen',
      '/portal/dashboard',
      '/moneymonastery-2025',
    ]);
    const load_chats_with_scroll = ['/ab-testing/hoy-los-bancos-ofrecen'];
    const no_load_chat_param_viewapp = new Set([
      '/retirar-cdt-antes-de-tiempo-es-posible-con-mejorcdt',
      '/portal/dashboard',
    ]);
    const no_load_chats_in_mobile = new Set([
      '/transfiere-el-dinero',
      '/v2/preguntas/coltefinanciera/flamingo?campaign=Flamingo',
      '/v2/preguntas-ban100',
      '/v2/preguntas-bancamia',
      '/v2/preguntas-bancow',
      '/v2/preguntas-bancomundomujer',
      '/v2/preguntas-mibanco',
      '/v2/preguntas-credifamilia',
      '/v2/preguntas-coltefinanciera',
      '/v2/preguntas-iris',
      '/v2/preguntas-cdturbo',
      '/v2/preguntas-koa',
      '/v2/datos-personales',
      '/v2/datos-financieros',
      '/confirma-tus-datos',
      '/cuentanos-sobre-ti',
      '/magical_experience/transfiere-el-dinero',
      '/magical_experience/cdt-completado',
      '/magical_experience/cuentanos-sobre-ti',
      'magical_experience/confirma-tus-datos',
    ]);
    const is_viewapp_includes_route = no_load_chat_param_viewapp.has(locationPath) || !!params.get('view');

    // Carga el chat en un scroll específico.
    if (this.shouldLoadChatOnScroll(locationPath, load_chats_with_scroll)) {
      return this.handleChatLoadOnScroll();
    } else {
      this.resetChatScrollState();
    }

    if (
      this.shouldNotLoadChat(
        locationPath,
        no_load_chaths_onpage,
        is_viewapp_includes_route,
        detect_screen_mode,
        views_no_loads_chaths_is_active_campaign_month,
        is_active_campaign_month,
        no_load_chats_in_mobile,
      )
    ) {
      return this.handleNoChatLoad();
    }

    if (campaignParam) {
      if (this.handleCampaignChatLoad(campaignParam, true)) return;
    }

    // Si ninguna de las condiciones anteriores (scroll, no-load, campaña)
    // se cumplió, ejecutamos el caso default (mejorcdt).

    this.updateFaviconsAndScript(
      `${this.env?.S3_STATIC_FILES}/images/web/favicons/new`,
      this.globals_var.CAMPAIGN_MEJORCDT,
    );
    this.scheduleHubspotLoadOnInteraction();
  }

  /**
   * Determina si la ruta actual requiere cargar el chat por scroll.
   * @param locationPath Ruta actual
   * @param scrollPaths Array de rutas que requieren scroll
   * @returns boolean
   */
  private shouldLoadChatOnScroll(locationPath: string, scrollPaths: string[]): boolean {
    return scrollPaths.includes(locationPath);
  }

  /**
   * Maneja la lógica de carga del chat cuando se hace scroll en la página.
   * Carga el chat si no ha sido cargado por scroll previamente.
   */
  private handleChatLoadOnScroll(): void {
    if (!this.chatLoadedByScroll) {
      this.removeChatScrollListener();
      this.chatScrollListener = () => {
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const docHeight = document.documentElement.scrollHeight - window.innerHeight;
        const scrollPercent = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
        if (scrollPercent >= 10) {
          this.updateFaviconsAndScript(
            `${this.env?.S3_STATIC_FILES}/images/web/favicons`,
            this.globals_var.CAMPAIGN_MEJORCDT,
          );

          if (!this.FORCE_NO_LOAD_CHAT) {
            this.chatLoadedByScroll = true;
            this.removeChatScrollListener();
          }
        }
      };
      window.addEventListener('scroll', this.chatScrollListener, { passive: true });
    }
  }

  /**
   * Reinicia el estado de carga por scroll para permitir recarga si el usuario navega entre rutas.
   */
  private resetChatScrollState(): void {
    this.removeChatScrollListener();
    this.chatLoadedByScroll = false;
  }

  private removeChatScrollListener(): void {
    if (!this.chatScrollListener) {
      return;
    }
    window.removeEventListener('scroll', this.chatScrollListener);
    this.chatScrollListener = undefined;
  }

  /**
   * Determina si no se debe cargar el chat en la ruta actual.
   * @returns boolean
   */
  private shouldNotLoadChat(
    locationPath: string,
    noLoadPaths: Set<string>,
    isViewApp: boolean,
    detectScreenMode: boolean,
    noLoadMonthPaths: Set<string>,
    isActiveMonth: boolean,
    no_load_chats_in_mobile: Set<string>,
  ): boolean {
    return (
      noLoadPaths.has(locationPath) ||
      isViewApp ||
      this.env.BRAND !== 'mcdt' ||
      (!detectScreenMode && noLoadMonthPaths.has(locationPath) && isActiveMonth) ||
      (!detectScreenMode && no_load_chats_in_mobile.has(locationPath))
    );
  }

  /**
   * Maneja la lógica de rutas donde no se debe cargar el chat.
   */
  private handleNoChatLoad(): void {
    this.updateFaviconsAndScript(
      `${this.env?.S3_STATIC_FILES}/images/web/favicons`,
      this.globals_var.CAMPAIGN_MEJORCDT,
    );
    if (window.HubSpotConversations?.widget) {
      window.HubSpotConversations.widget.remove();
    }
  }

  /**
   * Maneja la lógica de carga del chat por campaña.
   * @param campaignParam Valor del parámetro de campaña
   * @param delayScript Si es true, retrasa la carga del script hasta la interacción
   * @returns boolean Si se realizó una acción y se debe salir del método principal
   */
  private handleCampaignChatLoad(campaignParam: string, delayScript: boolean = false): boolean {
    const campaign = campaignParam.toLowerCase();

    if (campaign === this.globals_var.FLAMINGO.toLowerCase()) {
      this.updateFaviconsAndScript(
        'https://static.mejorcdt.com/assets/favicons/flamingo',
        this.globals_var.CAMPAIGN_FLAMINGO,
      );
      if (this.retryAttempts > 0) {
        this.retryAttempts = 0;

        if (delayScript) {
          this.scheduleHubspotLoadOnInteraction();
        } else {
          this.addScriptToHead(this.globals_var.HUBSPOT_PORTAL_SCRIPT);
        }
      }
      return true;
    }

    if (campaign === this.globals_var.CAMPAIGN_CLAUDIAURIBE.toLowerCase()) {
      this.updateFaviconsAndScript(
        'https://static.mejorcdt.com/assets/favicons/claudiauribe',
        this.globals_var.CAMPAIGN_CLAUDIAURIBE,
      );
      this.retryAttempts = 0;
      return true;
    }
    if (this.retryAttempts > 0) {
      this.retryAttempts--;
      setTimeout(() => this.LoadChatFaviconBrand(), 1000);
      return true;
    }
    return false;
  }

  updateFaviconsAndScript(faviconBaseUrl: string, brand: string) {
    const sizes = [16, 32, 48, 64, 128];
    sizes.forEach((size) => {
      if (this.env.BRAND != 'mcdt') {
        this.favicons[`ico${size}`].href = `${this.env.S3_STATIC_FILES}/brands/${this.env.BRAND}/img/icon${size}.png`;
      } else {
        if (brand === this.globals_var.CAMPAIGN_MEJORCDT) {
          this.favicons[`ico${size}`].href = `${faviconBaseUrl}/icon${size}.jpg`;
        } else {
          this.favicons[`ico${size}`].href = `${faviconBaseUrl}.png`;
        }
      }
    });
  }

  /* Si existe el paremetro tube, significa que el usuario accedio por el link y lo redireccionaremos al paso en que está  */
  backToStep() {
    const isIdProcess = !!this.utils.getQueryParam('process_id');
    const isIdTicket = !!this.utils.getQueryParam('ticket');
    const isPathHome = window.location.pathname === '/';
    const query_url = {
      process_id: this.utils.getQueryParam('process_id'),
      ticket: this.utils.getQueryParam('ticket'),
      campaign: this.utils.getQueryParam('campaign'),
    };
    if ((isIdProcess || isIdTicket) && isPathHome) {
      this.router.navigate(['/continuar-proceso'], { queryParams: query_url });
    }
  }

  /**
   * En TEST y DEV el widget debe consultar el chatflow 39373125.
   * HubSpot ignora un id de chatflow en el script y elige el flujo con
   * la URL de la página. Fijamos esa URL antes de insertar el tracker.
   * En PRO se deja la URL real para conservar el chatflow 40173135.
   */
  private pinHubspotChatflowForEnvironment(): void {
    if (this.env.ENVIRONMENT_NAME === 'production') return;

    window.messagesConfig = {
      ...(window.messagesConfig ?? {}),
      messagesPageUri: this.globals_var.HUBSPOT_TEST_MESSAGES_PAGE_URI,
    };
  }

  private addScriptToHead(src: string): void {
    // Asegurar que el src use HTTPS para cumplir con CSP
    const secureSrc = src.startsWith('//') ? `https:${src}` : src;
    const hubspotPortalScript = this.globals_var.HUBSPOT_PORTAL_SCRIPT;
    const isHubspotPortalScript = secureSrc === hubspotPortalScript;
    if (this.FORCE_NO_LOAD_CHAT && isHubspotPortalScript) {
      return;
    }

    if (isHubspotPortalScript) {
      this.pinHubspotChatflowForEnvironment();
      if (document.querySelector(`script[src="${hubspotPortalScript}"]`)) {
        return;
      }
    }

    const script = document.createElement('script');
    script.src = secureSrc;
    script.type = 'text/javascript';
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  }

  /* onWindowScroll() {
    if (!isPlatformBrowser(this.platformId)) return;

    const locationPath = window.location.pathname;
    const only_desktop_in_path = ['/portal/dashboard'];

    if (
      (this.globals_var.PATHS_SHOW_DOWNLOAD_APP_FULLSCREEN.includes(`${locationPath}`) ||
        locationPath.startsWith('/mejores-cdt-')) &&
      this.env.BRAND == 'mcdt'
    ) {
      const requiresDesktopOnly = only_desktop_in_path.includes(locationPath);
      if (requiresDesktopOnly && this.resolution !== 1) return;

      const threshold = 600;
      const position = window.innerHeight + window.scrollY;
      const height = document.body.offsetHeight;

      if (position >= height - threshold && !this.flagModalDownloadApp) {
        this.loadModalComponent();
        this.flagModalDownloadApp = true;
      }
    }
  } */

  /* private async loadModalComponent() {
    const { ModalDownloadAppFullscreenComponent } =
      await import('./modals/modal-download-app-fullscreen/modal-download-app-fullscreen.component');

    this.ngZone.run(() => {
      this.container.createComponent(ModalDownloadAppFullscreenComponent);
    });
  } */
}
